
import * as utc from "../util/utc.js";
import {resolveTimeCursor} from "../util/dates.js";
import {tr} from "../ux/translations.js";
import {capitalize} from "../util/strings.js";
import {ø} from "../util/objects.js";

export function describeSurface(attr) {
    return attr.z_level === "surface" ? tr`Surface` : capitalize(attr.z_level);
}

// UNDONE: better more generic name? not really specific to "validTime" calculation
/**
 * @param {object} parts
 * @param {object?} alignment
 * @param {object?} offset
 * @returns {{year: number, month: number, day: number, hour: number, minute: number, second: number, milli: number}}
 */
export function resolveValidTime(parts, alignment, offset) {
    const aligned = utc.floor(parts, alignment);
    return utc.normalize(utc.add(aligned, offset ?? {}));
}

// UNDONE: this function doesn't do much
export function newProduct() {
    return {
        descriptionHTML: undefined,

        paths: [],

        /** @returns {Object} the product's date parts. */
        validTime: function() {
            return null;
        },

        /** @returns {string} the product's appropriate date format string. */
        dateFormat: function() {
            return "{YYYY}-{MM}-{DD} {hh}:{mm} {TZ}";
        },

        alpha: {single: 160, animated: 112},
    };
}

function nav(time_cursor, alignment, offset, steps, labels) {
    const validTime = resolveValidTime(resolveTimeCursor(time_cursor), alignment, offset);
    const stepper = step => function() {
        return resolveValidTime(utc.add(this.validTime(), step), alignment);
    };
    return {
        alignment: () => ø(alignment),
        validTime: () => ø(validTime),
        prev2: stepper(steps.prev2),
        prev1: stepper(steps.prev1),
        next1: stepper(steps.next1),
        next2: stepper(steps.next2),
        navLabels: labels,
    };
}

/**
 * @param {string} time_cursor
 * @param {object?} offset
 */
export function nav1hr(time_cursor, offset) {
    return nav(time_cursor, {hour: 1}, offset, {
        prev2: {hour: -8},
        prev1: {hour: -1},
        next1: {hour: +1},
        next2: {hour: +8},
    }, {
        prev2: `-8 ${tr`hours`}`,
        prev1: `-1 ${tr`hour`}`,
        next1: `+1 ${tr`hour`}`,
        next2: `+8 ${tr`hours`}`,
    });
}

/**
 * @param {string} time_cursor
 * @param {object?} offset
 */
export function nav3hr(time_cursor, offset) {
    return nav(time_cursor, {hour: 3}, offset, {
        prev2: {day:  -1},
        prev1: {hour: -3},
        next1: {hour: +3},
        next2: {day:  +1},
    }, {
        prev2: `-1 ${tr`day`}`,
        prev1: `-3 ${tr`hours`}`,
        next1: `+3 ${tr`hours`}`,
        next2: `+1 ${tr`day`}`,
    });
}

/**
 * @param {string} time_cursor
 * @param {object?} offset
 */
export function nav1day(time_cursor, offset) {
    return nav(time_cursor, {day: 1}, offset, {
        prev2: {day: -5},
        prev1: {day: -1},
        next1: {day: +1},
        next2: {day: +5},
    }, {
        prev2: `-5 ${tr`days`}`,
        prev1: `-1 ${tr`day`}`,
        next1: `+1 ${tr`day`}`,
        next2: `+5 ${tr`days`}`,
    });
}
